import { InfiniteData, useInfiniteQuery, UseInfiniteQueryResult } from '@tanstack/react-query';
import { DEFAULT_QUERY_OPTIONS } from '@projects/queries/constants';
import { PaginatedFetchResult } from '../../../types';
import ScimAuditLog, { ScimAuditLogJSON } from '../models/ScimAuditLog';
import useScimSystem from '../systems/useScimSystem';
import { QueryKeys } from './keysAndFilters';

const asFlatList = ( data: InfiniteData<PaginatedFetchResult<ScimAuditLogJSON>> ) => (
	data.pages.flatMap( page => ScimAuditLog.allFromJSON( page.items ) )
);

const useScimAuditLogsQuery = ( { workspaceID }: { workspaceID: number } ) => {
	const system = useScimSystem();

	return useInfiniteQuery(
		QueryKeys.forScimAuditLogs( { workspaceID } ),
		( { pageParam = 1 } ) => system.fetchScimAuditLogs( { workspaceID, page: pageParam } ),
		{
			getNextPageParam: ( { pagination } ) => (
				pagination.last_page ? undefined : pagination.current + 1
			),
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			select: asFlatList,
			...DEFAULT_QUERY_OPTIONS
		}
	) as Omit<UseInfiniteQueryResult, 'data'> & { data?: ScimAuditLog[] };
};

export default useScimAuditLogsQuery;
